<template>
  <div>
    <!-- TOOLBAR -->
    <v-app-bar flat color="red-darken-3 py-3">
      <v-app-bar-title class="d-none d-sm-flex">
        {{ $t("users.label") }}
      </v-app-bar-title>

      <v-divider class="mx-5 d-none d-sm-flex" inset vertical />

      <!-- SEARCH -->
      <v-text-field
        v-model="search"
        :label="$t('users.search')"
        variant="solo"
        flat
        dense
        color="red-darken-1"
        single-line
        hide-details
        clearable
        autocomplete="off"
        class="mx-1 users-search-field"
      />

      <!-- <v-spacer class="d-none d-sm-flex" /> -->

      <!-- INSTITUTION SELECT -->
      <v-col
        v-if="
          $store.getters.role === 'LekoAdmin' ||
          $store.getters.role === 'LekoEmployee' ||
          $store.getters.role === 'SuperAdmin'
        "
        class="d-none d-sm-flex users-institution-col"
      >
        <v-autocomplete
          v-if="
            $store.getters.role === 'LekoAdmin' ||
            $store.getters.role === 'LekoEmployee' ||
            $store.getters.role === 'SuperAdmin'
          "
          v-model="institution"
          :items="institutions"
          :loading="loadingInstitution"
          :label="$t('parts.advanced_search.institution')"
          item-title="title"
          item-value="_id"
          variant="solo"
          clearable
          flat
          hide-details
          color="red-darken-1"
          autocomplete="off"
          class="users-institution-field"
        />
      </v-col>

      <!-- CLEAR SEARCH BUTTON -->
      <!-- <v-btn
        v-if="
          $store.getters.role === 'LekoAdmin' ||
          $store.getters.role === 'LekoEmployee' ||
          $store.getters.role === 'SuperAdmin'
        "
        class="ml-0 mr-1"
        small
        icon
        @click="clearSearch"
      >
        <v-icon color="white"> mdi-broom </v-icon>
      </v-btn> -->
      <v-spacer class="d-none d-sm-flex" />
      <!-- ADD USER BUTTON -->
      <v-btn
        v-if="
          $store.getters.role === 'LekoAdmin' ||
          $store.getters.role === 'LekoEmployee' ||
          $store.getters.role === 'InstitutionAdmin' ||
          $store.getters.role === 'SuperAdmin'
        "
        color="grey-darken-4"
        variant="flat"
        class=""
        @click="newUser"
      >
        {{ $t("users.button") }}
        <v-icon end>mdi-plus</v-icon>
      </v-btn>
    </v-app-bar>

    <!-- Mobile-only filters/actions under app-bar -->
    <div   v-if="
            $store.getters.role === 'LekoAdmin' ||
            $store.getters.role === 'LekoEmployee' ||
            $store.getters.role === 'SuperAdmin'
          " class="d-sm-none bg-red-darken-3 users-mobile-bar px-2 pt-4">
      <v-row class="ma-0" dense>
        <v-col
        
          cols="12"
        >
          <v-autocomplete
            v-model="institution"
            :items="institutions"
            :loading="loadingInstitution"
            :label="$t('parts.advanced_search.institution')"
            item-title="title"
            item-value="_id"
            variant="solo"
            clearable
            flat
            hide-details
            color="red-darken-1"
            autocomplete="off"
          />
        </v-col>
      </v-row>
    </div>

    <!-- ALERT -->
    <v-alert v-model="alert.value" type="error">
      {{ alert.message }}
    </v-alert>

    <!-- EDIT DIALOG -->
    <edit-dialog ref="editDialog" @close="getUsers" @error="''" />

    <!-- DATATABLE -->
    <datatable
      ref="datatable"
      class="mt-3"
      :search="search"
      :institution="institution"
      @edit="editUser"
    />
  </div>
</template>

<script>
import EditDialog from "@/components/Users/dialog.vue";
import Datatable from "@/components/Users/datatable.vue";
import getRequest from "../api/getRequest";

export default {
  components: {
    "edit-dialog": EditDialog,
    datatable: Datatable,
  },
  data: () => ({
    search: "",
    alert: {
      value: false,
      message: "",
    },
    institution: null,
    institutions: [],
    loadingInstitution: false,
  }),
  created() {
    this.getInstitutions();
  },
  methods: {
    clearSearch() {
      this.search = "";
      this.institution = null;
    },
    getInstitutions() {
      this.loadingInstitution = true;
      getRequest("/institution/")
        .then((response) => {
          this.institutions = response.institutions;
        })
        .catch(() => {})
        .finally(() => {
          this.loadingInstitution = false;
        });
    },
    showAlert() {
      this.alert = { value: true, message: "" };
      setTimeout(() => {
        this.alert = { value: false, message: "" };
      }, 2000);
    },
    newUser() {
      const { editDialog } = this.$refs;
      editDialog.open(false, null);
    },
    editUser(data) {
      const { editDialog } = this.$refs;
      editDialog.open(true, data);
    },
    getUsers() {
      const { datatable } = this.$refs;
      datatable.getUsers();
    },
  },
};
</script>

<style scoped>
/* Only affects mobile layout improvements below app-bar */
.users-mobile-bar {
  background: transparent;
}

@media (max-width: 599.98px) {
  /* Keep search usable inside app-bar on phones */
  .users-search-field {
    max-width: 210px;
  }
  .users-mobile-new-btn :deep(.v-btn__content) {
    white-space: nowrap;
  }
}

@media (min-width: 600px) {
  .users-search-field {
    min-width: 260px;
  }
  .users-institution-col {
    min-width: 260px;
  }
  .users-institution-field {
    min-width: 260px;
  }
}
</style>
